import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Skeleton,
  Button,
  Card,
  CardContent,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import "../css/NewAgentViewerScreen.css";
import { useDispatch, useSelector } from "react-redux";
import DescriptionIcon from '@mui/icons-material/Description';
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
} from "chart.js";
import { statusAiAgent } from "../redux/slices/StatusProgressSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { getStatisticsAgents } from "../redux/slices/StatisticsSlice";
import {
  deployAiAgent,
  resetDeployAgent,
  saveTaskId,
} from "../redux/slices/DeployAIAgent";
import { processedDocuments } from "../redux/slices/LoadAIAgentsSlice";
import { getProgressLoading } from "../redux/slices/ActiveSystemAiAgentLists";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { LinearProgress, Avatar, Paper } from "@mui/material";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import TaskIcon from "@mui/icons-material/Task";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DoughnutProgressCard from "../components/DoughnutProgressCard";
import StatusProgress from "../components/StatusProgress";
import BlueTile from "../components/BlueTile";
import { getImages, getProfileImage, getProfileImageWithStyle } from "../utills/lib";
import UploadPopup from "../components/UploadPopup";
ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale);

const NewAgentViewerScreen = () => {
  const DeploySliceData = useSelector((state) => state.DeploySlice);
  const { progressindData } = useSelector(
    (state) => state.ActiveSystemAiAgentLists
  );
  const { profileDetails: profile } = useSelector(
    (state) => state.ProfileSlice
  );
  const { processedDocumentsList } = useSelector(
    (state) => state.LoadAIAgentsSlice
  );
  const { slugName } = useSelector((state) => state.CreateAgentSlice);

  const { deployAgentLoading, deployAgent } = useSelector(
    (state) => state.DeploySlice
  );
  const { statusAgent, statusAgentLoading } = useSelector(
    (state) => state.StatusProgressSlice
  );
  const { statisticInfo, statisticInfoLoading } = useSelector(
    (state) => state.StatisticsSlice
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const receviedDatafromProps = location.state;
  const [durationFilter, setDurationFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [uploadPopupOpen, setUploadPopupOpen] = useState(false);

  // Remove auto-deploy - only deploy when Start button is clicked
  // useEffect(() => {
  //   // Only auto-deploy if we have received data from LoadMyAgent and no taskId exists
  //   if (receviedDatafromProps && DeploySliceData?.taskId == null) {
  //     handleRunAIAgent();
  //   }
  // }, [DeploySliceData, receviedDatafromProps]);

  console.log("receviedDatafromProps", receviedDatafromProps)

  useEffect(() => {
    let intervalId;
    if (DeploySliceData?.taskId) {

      // Call the API immediately on mount or when `DeploySliceData` changes
      dispatch(statusAiAgent(DeploySliceData.taskId));
      // Set up an interval to call the API every minute (60000 ms)
      intervalId = setInterval(() => {
        dispatch(statusAiAgent(DeploySliceData.taskId));
      }, 60000);
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [DeploySliceData, dispatch]);

  // Helper function to save taskId to localStorage
  const saveTaskIdToStorage = (taskId) => {
    if (taskId) {
      localStorage.setItem('agentTaskId', taskId);
    }
  };

  // Helper function to get taskId from localStorage
  const getTaskIdFromStorage = () => {
    const storedTaskId = localStorage.getItem('agentTaskId');
    if (storedTaskId) {
      return storedTaskId;
    }
    return null;
  };

  // Load taskId from localStorage on component mount
  useEffect(() => {
    const storedTaskId = getTaskIdFromStorage();
    if (storedTaskId && !DeploySliceData?.taskId) {
      dispatch(saveTaskId(storedTaskId));
    }
  }, [dispatch]);

  useEffect(() => {
    if (!deployAgentLoading && deployAgent) {
      // Save the task_id from the API response to Redux state
      const taskId = deployAgent?.data?.task_id;
      dispatch(saveTaskId(taskId));
      saveTaskIdToStorage(taskId); // Also save to localStorage
      dispatch(resetDeployAgent());
    }
  }, [deployAgent, deployAgentLoading, dispatch]);

  const handleRunAIAgent = () => {
    dispatch(deployAiAgent(slugName));
  };

  useEffect(() => {
    let intervalId;

    if (slugName && receviedDatafromProps) {
      // Call the API immediately on mount or when `DeploySliceData` changes
      dispatch(getProgressLoading(slugName));

      // Set up an interval to call the API every minute (60000 ms)
      intervalId = setInterval(() => {
        dispatch(getProgressLoading(slugName));
        dispatch(processedDocuments(slugName));
      }, 60000);
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [dispatch, slugName, receviedDatafromProps]);

  useEffect(() => {
    if (slugName && receviedDatafromProps) {
      dispatch(getStatisticsAgents(slugName));
      dispatch(processedDocuments(slugName));
    }
  }, [slugName, receviedDatafromProps]);

  useEffect(() => {
    if (
      statusAgent?.data?.status === "SUCCESS" ||
      statusAgent?.data?.status === "Success"
    ) {
      if (slugName && receviedDatafromProps) {
        dispatch(processedDocuments(slugName));
      }
      // Clear taskId when status is SUCCESS since we don't need to poll anymore
      clearTaskId();

      // Refresh the page after a short delay to show updated data
      // setTimeout(() => {
      //   window.location.reload();
      // }, 2000);
    }
  }, [statusAgent, receviedDatafromProps, slugName]);

  const clearTaskId = () => {
    localStorage.removeItem('agentTaskId');
  };

  const startAction = () => {
    // Clear any existing taskId when starting a new deployment
    clearTaskId();
    handleRunAIAgent();
    dispatch(getStatisticsAgents(slugName));
    dispatch(processedDocuments(slugName));
  };

  const stats = [
    {
      label: "Total Files",
      value: `${progressindData?.total_files ?? 0}`,
      icon: <FolderCopyIcon sx={{ color: "#fff", fontSize: 30 }} />,
      backgroundColor: "#5856d6",
      gradientTo: "#b8b6f6",
      statusKey: "all",
    },
    {
      label: "Processed Files",
      value: `${progressindData?.processed_files ?? 0}`,
      icon: <TaskIcon sx={{ color: "#fff", fontSize: 30 }} />,
      backgroundColor: "#edad20",
      gradientTo: "#fce6a1",
      statusKey: "processed",
    },
    {
      label: "In Progress Files",
      value: `${progressindData?.inprogress_files ?? 0}`,
      icon: <AutorenewIcon sx={{ color: "#fff", fontSize: 30 }} />,
      backgroundColor: "#009688",   // teal
      gradientTo: "#80cbc4",
      statusKey: "inprogress",
    },
    {
      label: "Rejected Files",
      value: `${progressindData?.rejected_files ?? 0}`,
      icon: <HighlightOffIcon sx={{ color: "#fff", fontSize: 30 }} />,
      backgroundColor: "#da5d5c",
      gradientTo: "#f3b6b5",
      statusKey: "rejected",
    },
    {
      label: "Pending Files",
      value: `${progressindData?.pending_files ?? 0}`,
      icon: <HourglassEmptyIcon sx={{ color: "#fff", fontSize: 30 }} />,
      backgroundColor: "#359aff",
      gradientTo: "#a8d4ff",
      statusKey: "pending",
    },
  ];
  // Sample data
  const tableData = Array.isArray(processedDocumentsList) ? processedDocumentsList : [];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const applyDurationFilter = (data, filter) => {
    // Ensure data is an array
    if (!Array.isArray(data)) {
      console.warn('applyDurationFilter: data is not an array', data);
      return [];
    }

    const now = new Date();
    const startOfToday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - now.getDay()); // Sunday as start of the week

    switch (filter) {
      case "today":
        return data.filter((item) => {
          const date = new Date(item.created_at);
          return date >= startOfToday;
        });

      case "currentWeek":
        return data.filter((item) => {
          const date = new Date(item.created_at);
          return date >= startOfWeek;
        });

      case "currentMonth":
        return data.filter((item) => {
          const date = new Date(item.created_at);
          return (
            date.getMonth() === now.getMonth() &&
            date.getFullYear() === now.getFullYear()
          );
        });

      case "last3Months":
        const threeMonthsAgo = new Date(now);
        threeMonthsAgo.setMonth(now.getMonth() - 3);
        return data.filter(
          (item) => new Date(item.created_at) >= threeMonthsAgo
        );

      case "last6Months":
        const sixMonthsAgo = new Date(now);
        sixMonthsAgo.setMonth(now.getMonth() - 6);
        return data.filter((item) => new Date(item.created_at) >= sixMonthsAgo);

      case "last1Year":
        const oneYearAgo = new Date(now);
        oneYearAgo.setFullYear(now.getFullYear() - 1);
        return data.filter((item) => new Date(item.created_at) >= oneYearAgo);

      case "all":
      default:
        return data;
    }
  };

  const filteredData = applyDurationFilter(
    statusFilter === "all"
      ? tableData
      : tableData.filter((row) => row.status === statusFilter),
    durationFilter
  );

  // Ensure filteredData is always an array
  const safeFilteredData = Array.isArray(filteredData) ? filteredData : [];

  // Auto-adjust rowsPerPage when data changes
  // useEffect(() => {
  //   if (safeFilteredData.length > 0 && rowsPerPage > safeFilteredData.length) {
  //     setRowsPerPage(safeFilteredData.length);
  //     setPage(0);
  //   }
  // }, [safeFilteredData.length, rowsPerPage]);

  return statisticInfoLoading ? (
    <div className="agent-list-container">
      {[...Array(10)].map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          width={200}
          height={120}
          sx={{ borderRadius: "8px", marginBottom: "16px" }}
        />
      ))}
    </div>
  ) : (
    <Box sx={{ p: 2, pl: 4, ml: 2 }}>
      {/* Top Row: Back Arrow + Text */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 2,
          justifyContent: "space-between",
          marginRight: "50px",
        }}
      >
        <div style={{ flexDirection: "row", display: "flex" }}>
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ArrowBackIcon
              sx={{ mr: 1, cursor: "pointer" }}
              onClick={() => {
                dispatch(resetDeployAgent());
                clearTaskId(); // Clear taskId when navigating away
                navigate("/LoadMyAgent", { state: { refresh: true } });
              }}
            />
          </div>

          <div>
            <Typography variant="h6">Collecting</Typography>
          </div>
        </div>

        {/* Show Start button when status is SUCCESS or when no status exists (new agent creation) */}
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          {(statusAgent?.data?.status === "SUCCESS" ||
            statusAgent?.data?.status === "Success" ||
            !statusAgent?.data?.status) && (
              <Button
                variant="contained"
                onClick={startAction}
                sx={{
                  backgroundColor: "#3B5CFF",
                  color: "white",
                  textTransform: "none",
                  borderRadius: "999px",
                  px: 3,
                  py: 1,
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "#3B5CFF",
                  },
                }}
              >
                Start
              </Button>
            )}

          {/* Upload Button */}
          <Button
            variant="contained"
            startIcon={<CloudUploadIcon />}
            onClick={() => setUploadPopupOpen(true)}
            sx={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              textTransform: 'none',
              borderRadius: '20px',
              px: 3,
              py: 1,
              fontWeight: 'bold',
              boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
              '&:hover': {
                background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
                boxShadow: '0 6px 16px rgba(102, 126, 234, 0.4)',
                transform: 'translateY(-1px)'
              },
              transition: 'all 0.3s ease'
            }}
          >
            Upload Files
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "stretch",
          gap: 2,
          flexWrap: "wrap",
          backgroundColor: "#f5f5f5",
          p: 2,
          borderRadius: 2,
        }}
      >
        <BlueTile
          title={`${profile?.first_name}\n`}
          subtitle={`${profile?.first_name} Agent\n${profile?.email}\nStatus: Sandbox`}
          imageSrc={receviedDatafromProps?.box?.profile_pic ? getProfileImageWithStyle(receviedDatafromProps.box.profile_pic).src : getImages(slugName)}
          agentData={statisticInfo?.data}
          bucketName={statisticInfo?.data?.bucket_name || receviedDatafromProps?.box?.bucket_name || "Default Bucket"}
          containerStyles={{
            width: "500px",
            height: "140px",
            backgroundColor: profile?.first_name === "Policy" && "#2AD899",
          }}
          imageStyles={{
            width: "70px",
          }}
        />
        <Box sx={{
          minWidth: 300,
          height: "180px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
          <DoughnutProgressCard
            value={progressindData?.progress_percentage ?? 0}
            label="Completion"
          />
        </Box>
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "180px",
          minWidth: 400
        }}>
          <StatusProgress
            activeStep={
              !statusAgent?.data?.status
                ? 3  // Show success when no status (no taskId)
                : statusAgent?.data?.status === "SUCCESS" ||
                  statusAgent?.data?.status === "Success"
                  ? 3
                  : statusAgent?.data?.status === "PENDING" ||
                    statusAgent?.data?.status === "Pending"
                    ? 2
                    : 1
            }
            statusAgent={statusAgent}
          />
        </Box>
      </Box>
      <Grid container columns={20} sx={{ mt: 3, mb: 2, gap: 0 }}>
        {stats.map((item, index) => (
          <Grid item xs={20} sm={10} md={4} key={index}>
            <Card
              sx={{
                position: "relative",
                overflow: "hidden",
                background: `linear-gradient(135deg, ${item.backgroundColor} 0%, ${item.gradientTo} 100%)`,
                boxShadow: `0 4px 12px ${item.backgroundColor}66`, // translucent shadow
                borderRadius: 2,
                width: "200px",
                height: "100%",
              }}
              elevation={3}
            >
              <CardContent
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                {item.icon}
                <Box>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "bold", color: "#fff" }}
                  >
                    {item.label}
                  </Typography>
                  <Typography
                    sx={{ fontWeight: "bold", color: "#fff", fontSize: "30px" }}
                    variant="h6"
                  >
                    {item.value}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Table Section */}
      <Box sx={{
        width: "95%",
        marginTop: 4,
        marginBottom: 3,
        position: "relative",
        zIndex: 1
      }}>

        {/* View More Button at Top-Right */}
        <Box sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          mt: 2
        }}>
          {/* Recent Documents Header - Left Side */}
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              color: "#1976d2",
              fontSize: { xs: "1.2rem", md: "1.5rem" },
              fontFamily: "'Poppins', sans-serif"
            }}
          >
            Recent Documents
          </Typography>

          {/* View More Button - Right Side */}
          <Button
            variant="contained"
            onClick={() => navigate("/AllProcessedDocuments", {
              state: {
                slugName,
                profilePic: receviedDatafromProps?.box?.profile_pic,
                receviedDatafromProps: receviedDatafromProps
              }
            })}
            sx={{
              background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
              color: "white",
              textTransform: "none",
              borderRadius: "25px",
              px: 3,
              py: 1,
              fontWeight: "bold",
              fontSize: "14px",
              boxShadow: "0 4px 15px rgba(25, 118, 210, 0.3)",
              "&:hover": {
                background: "linear-gradient(135deg, #1565c0 0%, #1976d2 100%)",
                boxShadow: "0 6px 20px rgba(25, 118, 210, 0.4)",
                transform: "translateY(-2px)",
              },
              transition: "all 0.3s ease",
              fontFamily: "'Poppins', sans-serif"
            }}
            startIcon={<VisibilityIcon />}
          >
            see all
          </Button>
        </Box>

        <TableContainer component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {["Agent Name", "File Name", "Created", "Status", "Actions"].map((header, i) => (
                  <TableCell
                    key={i}
                    sx={{
                      backgroundColor: "primary.main",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {safeFilteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <TableRow key={row.id} hover>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Avatar
                          src={receviedDatafromProps?.box?.profile_pic ? getProfileImageWithStyle(receviedDatafromProps.box.profile_pic).src : getImages(slugName)}
                          alt={row.ai_agent}
                          sx={{
                            width: 40,
                            height: 40,
                            ...(receviedDatafromProps?.box?.profile_pic ? getProfileImageWithStyle(receviedDatafromProps.box.profile_pic).style : {})
                          }}
                        />
                        {row.ai_agent}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <DescriptionIcon sx={{ fontSize: 18, verticalAlign: 'middle', mr: 1 }} />
                      {row.input_file_name}
                    </TableCell>
                    <TableCell>
                      {new Date(row.created_at).toLocaleString(undefined, {
                        year: "numeric",
                        month: "short",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit"
                      })}
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 1,
                          px: 2,
                          py: 0.5,
                          borderRadius: "999px",
                          backgroundColor:
                            row.status === "processed" || row.status === "success"
                              ? "#2AD899"
                              : row.status === "rejected"
                                ? "#C62828"
                                : "#F9A825",
                          color: "white",
                          fontWeight: "bold",
                          width: "100px",
                        }}
                      >
                        <Typography variant="body2">
                          {row.status === "processed" || row.status === "success"
                            ? "Processed"
                            : row.status === "rejected"
                              ? "Rejected"
                              : "Pending"}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<VisibilityIcon />}
                        sx={{
                          textTransform: "none",
                          fontFamily: "Poppins",
                          backgroundColor: (theme) => theme.palette.primary.main,
                          width: "80px",
                          justifyContent: "flex-start",
                          color: "white",
                          "&:hover": {
                            backgroundColor: (theme) =>
                              theme.palette.primary.dark,
                          },
                        }}
                        onClick={() =>
                          navigate("/ActivityDetailsScreen", {
                            state: {
                              row,
                              receviedDatafromProps: receviedDatafromProps
                            },
                          })
                        }
                      >
                        <Typography
                          sx={{
                            fontSize: "12px",
                          }}
                        >
                          View
                        </Typography>
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          {/* <TablePagination
            rowsPerPageOptions={(() => {
              const options = [5];
              if (safeFilteredData.length > 5) options.push(10);
              if (safeFilteredData.length > 10) options.push(25);
              if (safeFilteredData.length > 25) options.push(50);
              return options;
            })()}
            component="div"
            count={safeFilteredData.length}
            rowsPerPage={Math.min(rowsPerPage, safeFilteredData.length)}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          /> */}
        </TableContainer>
      </Box>

      {/* Upload Popup */}
      <UploadPopup
        open={uploadPopupOpen}
        onClose={() => setUploadPopupOpen(false)}
        slugName={slugName}
      />
    </Box>
  );
};

export default NewAgentViewerScreen;
